import { EnumCachedService } from './../cache-service/enum-cached.service';
import { EventEmitter, Injectable } from "@angular/core";
import { SystemcodeApi, SystemCodeEditOption } from "../api-service/system-code/systemcode-api";
import { IValueTextPair, ValueTextPair, ValueTextPairNumberValue } from "src/app/shared/models/value-text-pair";
import { HistService } from "src/app/hist/services/hist.service";
import { DosageDTO, HistApi, StatOpts } from "../api-service/hist/hist-api";
import { DxOpt, RsOpt, RxOpt, userStat } from "../api-service/hist/hist-edit-option";
import { EasyNotificationService } from "../easy-notification.service";
import { Compare, GroupBy, TrimEnd, delay } from "src/app/shared/utilities";
import { Subject } from "rxjs";
import { ParameterProfileCachedService } from "../cache-service/parameter-profile-cached.service";
import { SystemCodeCachedService } from "../cache-service/system-code-cached.service";
import { EnumTypes } from "../cache-service/enum-cached.service";
import { ParamMap, ParamMapKey, ParamType } from './system-param-cache-define';
import { ParameterApi } from '../api-service/parameters/parameter-api';
import { FormFieldCollection } from 'src/app/shared/components/easy-form/form-define';
import { ParameterDataType } from 'src/app/system/parameter-profile/models/parameter-profile';
import { EasyFormService } from '../easy-form-service';
import { ICacheReset} from '../cache-service/icache-service';
import { DateHelper } from 'src/app/shared/helpers/date-helper';
import { SpecialSameTreatDto, SpecialSameTreatRxDto } from '../api-service/val-addapp/special-sameTreat-dto';
import { TemporaryWorkApi } from '../api-service/val-addapp/temporaryWork-api';
import { Data } from '@angular/router';
import { PricingApi } from '../api-service/pricing/pricing-api';
import { UserCache } from '../user-cache';
import { ClinicTypeEnum } from 'src/app/enums/ClinicTypeEnum';
import { GPParameterCachedService } from '../cache-service/gp-parameter-cached.service';
import { OptionTypes, OptionsCachedService } from '../cache-service/options-cached.service';
import { CacheObject, ObjectCachedService } from '../cache-service/object-cached.service';
import { DiscountPriorityCachedService } from '../cache-service/discount-priority-cached.service';
import { DiscountCachedService } from '../cache-service/discount-cached.service';
import { NaturalDisasterRxCachedService } from '../cache-service/natural-disaster-rx-cached.service';
import { Hspid } from '../api-service/hspid/hspid';
import { MedLackArea } from '../api-service/medlackarea/medlackarea';
import { ClinicSession } from '../api-service/clinic/clinic-session-api.service';
import { ClinicApi, CmsPrintReport, GFNo, StartUpPreloadDto } from '../api-service/clinic/clinic-api';
import { ScheduleCachedService } from '../cache-service/schedule-cached.service';
import { PostAreaDto } from '../api-service/postarea-api';
import { BaseConfig, FunctionEnable } from '../base-config.service';
import { FullUser } from '../api-service/user/user-api';
import { DoctorScheduleDto } from '../api-service/schedule/schedule-api';
import { TherapistScheduleDto } from '../api-service/user/uesrSimpleInfo';
import { ChiHistApi } from '../api-service/hist/chi-hist-api';
import { HST002Params } from '../api-service/parameters/HST002Params';
import { SYS101Params } from '../api-service/parameters/SYS101Params';
import { SessionService } from '../session.service';
import { Clinic } from 'src/app/system/clinic/models/clinic';

export declare type ValueTextPairBundle = { [key: string]: ValueTextPair[] };
export declare type NumberValueTextPairBundle = { [key: string]: ValueTextPairNumberValue[] };
export declare type DxVersionTag = '2014'|'2023'|''
enum UpdateType {
  Insert = 1,
  Update = 2,
  Delete = 3
}
@Injectable({
  providedIn: 'root'
})

//快取資料
export class ClinicDataService {
  showDataChangedNotify = true;
  private rxOption: RxOpt[];
  private rsOption: RsOpt[];
  private dxOption: DxOpt[];
  dxVersion: string = '';
  statOpt: StatOpts = null;
  allICache:ICacheReset[] = [];
  onParamChanged: EventEmitter<ParamType[]> = new EventEmitter();
  onReload:EventEmitter<void> = new EventEmitter();
  onPreload:EventEmitter<void> = new EventEmitter();
  gf:GFNo = null;
  lastestPreloadDto:StartUpPreloadDto = null;
  private startUpPreloadCompletedAt = 0;
  private startUpPreloadPromise?: Promise<StartUpPreloadDto>;
  private readonly startUpPreloadIntervalMs = 15 * 1000;
  private cmsPrintReports:Map<string,CmsPrintReport> = new Map();

  constructor(private histApi: HistApi,
    private chiHistApi:ChiHistApi,
    private notify: EasyNotificationService,
    private ParameterProfileCache: ParameterProfileCachedService,
    private GPParameterCachedService: GPParameterCachedService,
    private SystemCodeCached: SystemCodeCachedService,
    private optionsCachedService: OptionsCachedService,
    private ObjectCachedService:ObjectCachedService,
    private DiscountPriorityCachedService:DiscountPriorityCachedService,
    private DiscountCachedService:DiscountCachedService,
    private NaturalDisasterRxCachedService:NaturalDisasterRxCachedService,
    private ScheduleCachedService:ScheduleCachedService,
    private EnumCached: EnumCachedService,
    private paramApi:ParameterApi,
    private clinicApi:ClinicApi,
    private ezForm:EasyFormService,
    private session:SessionService) {
      // 新快取類型時做完以後要加入這個地方 統一重載/清除
      this.allICache.push(SystemCodeCached,EnumCached,ParameterProfileCache,GPParameterCachedService,optionsCachedService,
        ObjectCachedService,DiscountPriorityCachedService,DiscountCachedService,NaturalDisasterRxCachedService
      );
  }
  //#region  Server端列舉
  async getEnum(types: EnumTypes[]): Promise<NumberValueTextPairBundle> {
    await this.EnumCached.load(types);
    var ret: NumberValueTextPairBundle = {};
    for(let tp of types){
      let kerStr = tp.toString();
      ret[kerStr] = await this.EnumCached.get(tp);

    }
    return ret;
  }
  //#endregion

  //#region 參數
  async preload(localData?:StartUpPreloadDto):Promise<StartUpPreloadDto>{
    var data:StartUpPreloadDto = null;

    this.restoreStartUpPreload();

    if (this.startUpPreloadPromise) {
      console.info('[ClinicDataService] Reusing in-flight StartUpPreload request.');
      data = await this.startUpPreloadPromise;
    } else if (this.lastestPreloadDto && Date.now() - this.startUpPreloadCompletedAt < this.startUpPreloadIntervalMs) {
      // 如果上次的快取資料還在有效時間10分鐘內，就直接使用快取資料，避免頻繁呼叫 API
      data = this.lastestPreloadDto;
      console.info('[ClinicDataService] Skipping StartUpPreload API call; the previous request completed less than 10 minutes ago.');
    } else {
      this.startUpPreloadPromise = this.clinicApi.StartUpPreload();
      try {
        data = await this.startUpPreloadPromise;
        this.lastestPreloadDto = data;
        this.startUpPreloadCompletedAt = Date.now();
        this.saveStartUpPreload();
        console.info('[ClinicDataService] StartUpPreload completed at ' + new Date(this.startUpPreloadCompletedAt).toISOString());
      } catch (error) {
        console.error('[ClinicDataService] StartUpPreload failed.', error);
        throw error;
      } finally {
        delete this.startUpPreloadPromise;
      }
    }
    
    // Server端取得當前支援SignalR Hub的網址
    if(data.hubUrl){
      BaseConfig.getConfig().webApi.hubUrl = TrimEnd(data.hubUrl,'/')+'/';
    }else{
      BaseConfig.getConfig().webApi.hubUrl = BaseConfig.getConfig().webApi.hisBaseUrl;
    }

    console.log(data.log)
    this.cmsPrintReports.clear();
    for (const report of data.cmsReports || []) {
      if (report && report.Code) {
        this.cmsPrintReports.set(report.Code, {
          Code: report.Code,
          Template: report.Template,
          Type: report.Type
        });
      }
    }
    for(let k in data.param){
      this.ParameterProfileCache.set(k as any,data.param[k])
    }
    for(let k in data.systemCodes){
      this.SystemCodeCached.set(k,data.systemCodes[k])
    }
    for(let k in data.enums){
      this.EnumCached.set(k as EnumTypes,data.enums[k])
    }
    this.ObjectCachedService.set('CurrentUser',data.currentUser);
    this.ObjectCachedService.set('CityArea',data.cityArea);
    this.ObjectCachedService.set('ClinicSession',data.clinicSession)
    this.ObjectCachedService.set('HSPID',data.hspids.data)
    this.ObjectCachedService.set('MedLackArea',data.medLackArea);
    this.ObjectCachedService.set('NhiImi',data.nhiIMISetting);
    this.ObjectCachedService.set('SpecialSameTreat',data.specialSameTreat);
    this.ObjectCachedService.set('DxOpt2023',data.dxOpt);
    this.ObjectCachedService.set('RxOpt',data.rxOpt);
    this.ObjectCachedService.set('RsOpt',data.rsOpt);
    this.ObjectCachedService.set('Executor',data.executor);
    this.ObjectCachedService.set('SystemCodeOptions',data.systemCodeOptions);
    this.ObjectCachedService.set('Dosage',data.dosages);

    
    //this.ObjectCachedService.set('SpSameTreatRxs','')

    this.optionsCachedService.set(OptionTypes.Doctors,data.doctor);
    this.optionsCachedService.set(OptionTypes.Pharmacist,data.pharmacist);
    this.optionsCachedService.set(OptionTypes.PCSx2023,data.pcsx.data.map(x=>{return {value:x.ApplyCode,text:x.CName}}));
    this.optionsCachedService.set(OptionTypes.SpcTOption,data.spcOpt)

    for (let ind =0; ind<data.gpPara.gpPara.length;ind++) {
      // 快取Key存的是編號
      this.GPParameterCachedService.set(ind+1,data.gpPara.gpPara[ind]);
    }
    this.DiscountPriorityCachedService.set(DateHelper.today.toLocaleDateString(),data.discountPriority);
    this.DiscountCachedService.set(DateHelper.today.toLocaleDateString(),data.discounts);
    this.NaturalDisasterRxCachedService.set(DateHelper.today.toLocaleDateString(),data.naturalDisasterRx);
    this.ScheduleCachedService.set('D_'+DateHelper.today.toLocaleDateString(),data.schedule);
    this.ScheduleCachedService.set('P_'+DateHelper.today.toLocaleDateString(),data.schePhar);
    this.ScheduleCachedService.set('R_'+DateHelper.today.toLocaleDateString(),data.RehabitMedUesr.map(x=>{
      return {
        PositionCodes:[x.PositionCode],
        UserCID:x.CId,
        UserName:x.Name,
        Date:DateHelper.today,
        TimeSec:x.TimeSec,DefaPharm:0,DeptCode:''  ,UserId:0,RoomCode:x.Account
      }
    }));
    this.gf = data.gf;
    this.onPreload.emit();
    return data;
  }

  private getStartUpPreloadStorageKey(): string | null {
    const user = UserCache.getLoginUser();
    const clinicId = user?.Clinic?.Id || sessionStorage.getItem('ClinicId');
    if (!clinicId || !user?.UserId) {
      return null;
    }
    return 'ClinicData.StartUpPreload.' + clinicId + '.' + (user.CompanyCode || '') + '.' + user.UserId;
  }

  private restoreStartUpPreload(): void {
    if (this.lastestPreloadDto) {
      return;
    }
    try {
      const key = this.getStartUpPreloadStorageKey();
      const cached = key ? JSON.parse(sessionStorage.getItem(key) || 'null') : null;
      const age = cached ? Date.now() - cached.completedAt : -1;
      if (cached && cached.data && age >= 0 && age < this.startUpPreloadIntervalMs) {
        this.lastestPreloadDto = cached.data;
        this.startUpPreloadCompletedAt = cached.completedAt;
      } else if (cached && key) {
        sessionStorage.removeItem(key);
      }
    } catch (error) {
      console.warn('[ClinicDataService] Unable to restore StartUpPreload from session storage.', error);
    }
  }

  private saveStartUpPreload(): void {
    try {
      const key = this.getStartUpPreloadStorageKey();
      if (key) {
        sessionStorage.setItem(key, JSON.stringify({
          completedAt: this.startUpPreloadCompletedAt,
          data: this.lastestPreloadDto
        }));
      }
    } catch (error) {
      console.warn('[ClinicDataService] Unable to persist StartUpPreload in session storage.', error);
    }
  }

  async getParam<K extends keyof ParamMap>(type:K): Promise<ParamMap[K]> {
    await this.ParameterProfileCache.load([type]);
    var p = await this.ParameterProfileCache.get(type);
    // 測試用
    // if(type =='HST002'){
    //   (p as HST002Params).TypeColor = "{\"CC\":{\"f\":\"#000000\",\"b\":\"#eeff00\"},\"PE\":{\"f\":\"#000000\",\"b\":\"#00ffcc\"},\"DX\":{\"f\":\"#ffffff\",\"b\":\"#f06060\"},\"MS\":{\"f\":\"\",\"b\":\"\"},\"RX\":{\"f\":\"\",\"b\":\"#c1fbac\"},\"Freq\":{\"f\":\"\",\"b\":\"#fdd568\"},\"Days\":{\"f\":\"\",\"b\":\"#fda9fe\"},\"Way\":{\"f\":\"\",\"b\":\"\"},\"Dose\":{\"f\":\"\",\"b\":\"#a4bffe\"},\"CMD\":{\"f\":\"\",\"b\":\"\"},\"RX_2\":{\"f\":\"\",\"b\":\"\"},\"RX_3\":{\"f\":\"\",\"b\":\"\"},\"RX_4\":{\"f\":\"\",\"b\":\"\"},\"RX_6\":{\"f\":\"\",\"b\":\"\"},\"RX_7\":{\"f\":\"\",\"b\":\"\"},\"RX_8\":{\"f\":\"\",\"b\":\"\"},\"RX_9\":{\"f\":\"\",\"b\":\"\"},\"RX_12\":{\"f\":\"\",\"b\":\"\"},\"RX_5\":{\"f\":\"\",\"b\":\"\"},\"RX_11\":{\"f\":\"\",\"b\":\"\"},\"RX_10\":{\"f\":\"\",\"b\":\"\"},\"RX_18\":{\"f\":\"\",\"b\":\"\"}}";
    // }
    return p;
  }
  getParamCacheObj(){
    return this.ParameterProfileCache.cache;
  }
  async updateParam(type:(keyof ParamMap)[]): Promise<void> {
    await this.ParameterProfileCache.update(type);
    if (type.some(x => x === 'PRN001' || x === 'PRN003' || x === 'OFF001')) {
      await this.refreshCmsPrintReportKeys();
    }
    this.onParamChanged.emit(type);
  }
  async ReloadParams() {
    await this.ParameterProfileCache.reload();
  }
  //#endregion


  //#region SystemCodeCacheHandle
  /** value=Code, text=Name, extension=Name1, ext2=Name2, ext3=Attribute, ext4=Name3 */
  async getSystemCodes(types: string[]): Promise<ValueTextPairBundle> {
    await this.SystemCodeCached.load(types);
    var ret: ValueTextPairBundle = {};
    for(let tp of types){
      let kerStr = tp.toString();
      ret[kerStr] = await this.SystemCodeCached.get(tp);
    }
    return ret;
  }
  /** 更新指定類別的代碼快取 */
  async UpdateSystemCode(type: string[]) {
    await this.SystemCodeCached.update(type);
  }
  async DeleteSystemCode(type: string[]) {
    await this.SystemCodeCached.delete(type);
  }
  /** 系統代碼快取全部重撈 */
  async ReloadSystemCode() {
    await this.SystemCodeCached.reload();
  }

  getSystemCodeCacheObj(){
    return this.SystemCodeCached.cache;
  }
  //#endregion

  //#region Objects

  async GetCurrentUser(): Promise<FullUser> {
    await this.ObjectCachedService.load(['CurrentUser']);
    return await this.ObjectCachedService.get('CurrentUser')
  }
  async GetCityArea(): Promise<PostAreaDto> {
    await this.ObjectCachedService.load(['CityArea']);
    return await this.ObjectCachedService.get('CityArea')
  }
  public async GetNhiImiSetting(){
    await this.ObjectCachedService.load(['NhiImi']);
    return await this.ObjectCachedService.get('NhiImi');
  }
  public async UpdateNhiImiSetting(){
    await this.ObjectCachedService.update(['NhiImi']);
  }
  async GetTotalRahabitUser(): Promise<TherapistScheduleDto[]> {
    await this.ObjectCachedService.load(['RahbitUser']);
    return await this.ObjectCachedService.get('RahbitUser')
  }
  async GetSpecialSameTreat(): Promise<SpecialSameTreatDto[]> {
    await this.ObjectCachedService.load(['SpecialSameTreat']);
    return await this.ObjectCachedService.get('SpecialSameTreat')
  }
  async UpdateSpecialSameTreat() {
    await this.ObjectCachedService.update(['SpecialSameTreat']);
  }

  async GetSpecialSameTreatRx(): Promise<SpecialSameTreatRxDto[]> {
    await this.ObjectCachedService.load(['SpSameTreatRxs']);
    return await this.ObjectCachedService.get('SpSameTreatRxs')
  }
  async GetHspid(hType:number): Promise<Hspid[]> {
    await this.ObjectCachedService.load(['HSPID']);
    var data = await this.ObjectCachedService.get('HSPID')
    // 1 2一起算
    if (hType == 11){
      return data.filter(x => x.Htype == 1 || x.Htype == 2 || x.Htype == 3)
    }
    return data.filter(x=>hType==1||hType==2?( x.Htype==1|| x.Htype==2): x.Htype==hType)
  }
  async UpdateHspid() {
    await this.ObjectCachedService.update(['HSPID']);
  }
  async GetMedLackArea(type:'ALL'|'EC'): Promise<MedLackArea[]> {
    await this.ObjectCachedService.load(['MedLackArea']);
    var data = await this.ObjectCachedService.get('MedLackArea')
    if(type=='ALL'){
      return data;
    }else{
      return data.filter(x=>x.Data_type==type)
    }
  }
  async UpdateMedLackArea() {
    await this.ObjectCachedService.update(['MedLackArea']);
  }
  async GetClinicSession(id:number): Promise<ClinicSession> {
    var data = await this.GetClinicSessions();
    return data.find(x=>x.Id==id);
  }
  async GetClinicSessions(): Promise<ClinicSession[]> {
    await this.ObjectCachedService.load(['ClinicSession']);
    var data = await this.ObjectCachedService.get('ClinicSession')
    return data;
  }
  async UpdateClinicSession() {
    await this.ObjectCachedService.update(['ClinicSession']);
  }

  async GetDosages(): Promise<DosageDTO[]> {
    await this.ObjectCachedService.load(['Dosage']);
    var data = await this.ObjectCachedService.get('Dosage')
    return data;
  }
  async UpdateDosages() {
    await this.ObjectCachedService.update(['Dosage']);
  }

  async GetDoctorSchdule(date:Date){
    if(!date){
      date = DateHelper.today;
    }else{
      date = new Date(date);
    }
    // 以日期做快取
    var k = 'D_' + date.toLocaleDateString();
    await this.ScheduleCachedService.load([k]);
    return await this.ScheduleCachedService.get(k)
  }
  async UpdateDoctorSchdule(date:Date){
    if(!date){
      date = DateHelper.today;
    }else{
      date = new Date(date);
    }
    // 以日期做快取
    var k =  'D_' + date.toLocaleDateString();
    await this.ScheduleCachedService.update([k]);
  }
  async GetPharSchdule(date:Date){
    if(!date){
      date = DateHelper.today;
    }else{
      date = new Date(date);
    }
    // 以日期做快取
    var k = 'P_' + date.toLocaleDateString();
    await this.ScheduleCachedService.load([k]);
    return await this.ScheduleCachedService.get(k)
  }
  async UpdatePharSchdule(date:Date){
    if(!date){
      date = DateHelper.today;
    }else{
      date = new Date(date);
    }
    // 以日期做快取
    var k =  'P_' + date.toLocaleDateString();
    await this.ScheduleCachedService.update([k]);
  }
  async GetRehabitMedUesr(date:Date):Promise<TherapistScheduleDto[]>{
    if(!date){
      date = DateHelper.today;
    }else{
      date = new Date(date);
    }
    // 以日期做快取
    var k = 'R_' + date.toLocaleDateString();
    await this.ScheduleCachedService.load([k]);
    var obj= await this.ScheduleCachedService.get(k)
    console.log('obj',obj);
    return obj.map(x=>{
      return {
        PositionCode:x.PositionCodes[0],
        CId:x.UserCID,
        Name:x.UserName,
        Account:x.RoomCode,
        TimeSec:x.TimeSec,
      }
    })

  }
  async UpdateRehabitMedUesr(date:Date){
    if(!date){
      date = DateHelper.today;
    }else{
      date = new Date(date);
    }
    // 以日期做快取
    var k =  'R_' + date.toLocaleDateString();
    await this.ScheduleCachedService.update([k]);
  }
  async ReloadSchedule(){
    await this.ScheduleCachedService.reload();
  }

  async GetExecutor(): Promise<IValueTextPair<string>[]> {
    await this.ObjectCachedService.load(['Executor']);
    var data = await this.ObjectCachedService.get('Executor')
    return data;
  }
  async UpdateExecutor() {
    await this.ObjectCachedService.update(['Executor']);
  }

  async GetSystemCodeOptions(): Promise<SystemCodeEditOption> {
    await this.ObjectCachedService.load(['SystemCodeOptions']);
    var data = await this.ObjectCachedService.get('SystemCodeOptions')
    return data;
  }
  async UpdateSystemCodeOptions() {
    await this.ObjectCachedService.update(['SystemCodeOptions']);
  }
  async GetClinicList(): Promise<Clinic[]> {
    await this.ObjectCachedService.load(['SystemCodeOptions']);
    var data = await this.ObjectCachedService.get('SystemCodeOptions')
    return data?.clinicList;
  }

  
  async GetSTCMSingle(): Promise<string[]> {
    await this.ObjectCachedService.load(['STCMSingle']);
    var data = await this.ObjectCachedService.get('STCMSingle')
    return data;
  }
  //#endregion

  //#region Discount相關
  async GetDiscountPriority(regDate:Date){
    if(!regDate){
      regDate = DateHelper.today;
    }else{
      regDate = new Date(regDate);
    }
    // 以日期做快取
    var k = regDate.toLocaleDateString();
    await this.DiscountPriorityCachedService.load([k]);
    return await this.DiscountPriorityCachedService.get(k)
  }
  async UpdateDiscountPriority(regDate:Date){
    if(!regDate){
      regDate = DateHelper.today;
    }else{
      regDate = new Date(regDate);
    }
    // 以日期做快取
    var k = regDate.toLocaleDateString();
    await this.DiscountPriorityCachedService.update([k]);
  }
  async ReloadDiscountPriority(){
    await this.DiscountPriorityCachedService.reload();
  }

  async GetDiscount(regDate:Date){
    if(!regDate){
      regDate = DateHelper.today;
    }else{
      regDate = new Date(regDate);
    }
    // 以日期做快取
    var k = regDate.toLocaleDateString();
    await this.DiscountCachedService.load([k]);
    return await this.DiscountCachedService.get(k)
  }
  async UpdateDiscount(regDate:Date){
    if(!regDate){
      regDate = DateHelper.today;
    }else{
      regDate = new Date(regDate);
    }
    // 以日期做快取
    var k = regDate.toLocaleDateString();
    await this.DiscountCachedService.update([k]);
  }
  async ReloadDiscount(){
    await this.DiscountCachedService.reload();
  }
  //#endregion

  //#region NaturalDisasterRx
  async GetNaturalDisasterRx(regDate:Date){
    if(!regDate){
      regDate = DateHelper.today;
    }else{
      regDate = new Date(regDate);
    }
    // 以日期做快取
    var k = regDate.toLocaleDateString();
    await this.NaturalDisasterRxCachedService.load([k]);
    return await this.NaturalDisasterRxCachedService.get(k);
  }
  async UpdateNaturalDisasterRx(regDate:Date){
    if(!regDate){
      regDate = DateHelper.today;
    }else{
      regDate = new Date(regDate);
    }
    // 以日期做快取
    var k = regDate.toLocaleDateString();
    await this.NaturalDisasterRxCachedService.update([k]);
  }
  async ReloadNaturalDisasterRx(){
    await this.NaturalDisasterRxCachedService.reload();
  }
  //#endregion

  //#region Option
  async getOptions(type: OptionTypes): Promise<IValueTextPair<any>[]> {
    await this.optionsCachedService.load([type]);
    return await this.optionsCachedService.get(type);
  }
  async UpdateOptions(type:OptionTypes){
    await this.optionsCachedService.update([type])
  }

  //#endregion

  //#region GPPara
  /** pNo: p參數編號 */
  async getGPPara(pNo:number):Promise<string>{
    await this.GPParameterCachedService.load([pNo]);
    return await this.GPParameterCachedService.get(pNo);
  }
  async updateGPPara(): Promise<void> {
    await this.GPParameterCachedService.reload();
    //this.onParamChanged.emit(type);
  }
  //#endregion

  getSnapshot<K extends keyof CacheObject>(key: K){
    return this.ObjectCachedService.getSnapshot(key)
  }

  getCmsPrintReport(code:string):CmsPrintReport {
    if (!code) {
      return null;
    }
    return this.cmsPrintReports.get(code);
  }

  async updateCmsPrintReport(code:string, template:string, type:number):Promise<void> {
    if (!code) {
      return;
    }
    const isCached = this.cmsPrintReports.has(code);
    if (isCached || await this.isCmsPrintCode(code)) {
      this.cmsPrintReports.set(code, { Code: code, Template: template, Type: type });
    }
  }

  removeCmsPrintReport(code:string):void {
    if (code) {
      this.cmsPrintReports.delete(code);
    }
  }

  private async isCmsPrintCode(code:string):Promise<boolean> {
    const codes = await this.getCmsPrintCodes();
    return codes.indexOf(code) >= 0;
  }

  private async getCmsPrintCodes():Promise<string[]> {
    const prn001 = await this.getParam('PRN001');
    const prn003 = await this.getParam('PRN003');
    const off001 = await this.getParam('OFF001');
    return [
      prn001?.ReceiptCode,
      prn001?.HistoryCode,
      prn001?.WayCode,
      prn001?.RepeatPresCode,
      prn001?.RegisterCode,
      prn001?.DispExampCode,
      prn001?.InjectFormCode,
      prn001?.CtrDrugsCode,
      prn001?.ReserveCode,
      prn001?.ArrearReceiptCode,
      prn001?.ChineseDetailReceiptCode,
      off001?.ReceiptCode,
      off001?.WayCode,
      prn003?.CustomDrugBag,
      prn003?.CustomDrugBag2
    ].filter(x => !!x);
  }

  private async refreshCmsPrintReportKeys():Promise<void> {
    const codes = await this.getCmsPrintCodes();
    for (const code of Array.from(this.cmsPrintReports.keys())) {
      if (codes.indexOf(code) < 0) {
        this.cmsPrintReports.delete(code);
      }
    }
  }

  clearCache() {
    this.cmsPrintReports.clear();
    this.allICache.forEach(x=>x.clearCache());
  }

  //#region RX
  async GetRxOption(): Promise<RxOpt[]> {
    if(FunctionEnable.EnableClientAdvCache){
      await this.ObjectCachedService.load(['RxOpt']);
      return await this.ObjectCachedService.get('RxOpt');
    }else{
      await this.rxLock.doInLock(async () => {
        if (!this.rxOption) {
          if(UserCache.IsChineseMode()){
            this.rxOption = await this.chiHistApi.GetChiRxOptions();
          }else{
            this.rxOption = await this.histApi.GetRxOptions();
          }
        }
      });
      return this.rxOption;
    }

  }
  rxNotifyFlag = 0;
  async UpdateRx(rxOpt: { UpdateType: UpdateType, Data: RxOpt }[]) {
    var cachedRxOpt:RxOpt[];
    if(FunctionEnable.EnableClientAdvCache){
      cachedRxOpt = await this.GetRxOption()
    }else{
      cachedRxOpt = this.rxOption
    }
    if (cachedRxOpt) {
      rxOpt.forEach(x => {
        if (x.UpdateType == UpdateType.Insert) {
          if(UserCache.IsPharmacyMode() && !!x.Data.RxCode){
            // 藥局要把標準Opt移除 置換為院內Opt
            //cachedRxOpt = cachedRxOpt.filter(y => y.StdCode !== x.Data.StdCode && !y.RxCode);
            cachedRxOpt = cachedRxOpt.filter(y => !(y.StdCode == x.Data.StdCode && !y.RxCode));
          }
          // 避免重複
          var exist = cachedRxOpt.some(y => y.Id == x.Data.Id);
          if (!exist) {
            cachedRxOpt.push(x.Data);
          }


        } else if (x.UpdateType == UpdateType.Update) {
          //更新
          var opt = cachedRxOpt.find(y => y.Id == x.Data.Id)
          if (opt) {
            Object.assign(opt, x.Data);
          }
        } else if (x.UpdateType == UpdateType.Delete) {
          //留下沒有在移除清單中的
          cachedRxOpt = cachedRxOpt.filter(y => y.Id !== x.Data.Id);
        }
      })
      cachedRxOpt = cachedRxOpt.sort((a, b) => Compare(a.RxCode, b.RxCode));

      if(FunctionEnable.EnableClientAdvCache){
        this.ObjectCachedService.set('RxOpt',cachedRxOpt);
      }else{
        this.rxOption = cachedRxOpt
      }
      this.rxNotifyFlag = 1;
      setTimeout(() => {
        if(this.rxNotifyFlag ==1){
          this.rxNotifyFlag = 0;
          this.showNotify('院內醫令已變更…');
        }
      }, 1500);
      //this.rxOption = await this.histApi.GetRxOptions();
      this.showNotify('院內醫令已變更…');
    }
  }

  async GetRsOption(): Promise<RsOpt[]> {
    if(FunctionEnable.EnableClientAdvCache){
      await this.ObjectCachedService.load(['RsOpt']);
      return await this.ObjectCachedService.get('RsOpt');
    }else{
      await this.rsLock.doInLock(async () => {
        if (!this.rsOption) {
          this.rsOption = await this.histApi.GetRsOptions();
        }
      });
      return this.rsOption;
    }
  }

  async UpdateRs(rsOpt: { UpdateType: UpdateType, Data: RsOpt }[]) {

    var cachedRsOpt:RsOpt[];
    if(FunctionEnable.EnableClientAdvCache){
      cachedRsOpt = await this.GetRsOption()
    }else{
      cachedRsOpt = this.rsOption
    }
    if (cachedRsOpt) {
      rsOpt.forEach(x => {
        if (x.UpdateType == UpdateType.Insert) {
          // 避免重複
          var exist = cachedRsOpt.some(y => y.MainSetId == x.Data.MainSetId && y.RxId == x.Data.RxId);
          if (!exist) {
            cachedRsOpt.push(x.Data);
          }
        } else if (x.UpdateType == UpdateType.Update) {
          //更新
          var opt = cachedRsOpt.find(y => y.MainSetId == x.Data.MainSetId && y.RxId == x.Data.RxId)
          if (opt) {
            Object.assign(opt, x.Data);
          } else {
            cachedRsOpt.push(x.Data);
          }
        } else if (x.UpdateType == UpdateType.Delete) {
          //留下沒有在移除清單中的
          cachedRsOpt = cachedRsOpt.filter(y => y.MainSetId !== x.Data.MainSetId);
        }
      })
      cachedRsOpt = cachedRsOpt.sort((a, b) => Compare(a.RsCode, b.RsCode));
      if(FunctionEnable.EnableClientAdvCache){
        this.ObjectCachedService.set('RsOpt',cachedRsOpt);
      }else{
        this.rsOption = cachedRsOpt
      }
      //this.rxOption = await this.histApi.GetRxOptions();
      this.showNotify('組合套餐已變更…');
    }
  }
  //#endregion
  dxLock = new loadHelper();
  rxLock = new loadHelper();
  rsLock = new loadHelper();
  statLock = new loadHelper();

  //#region DX
  async GetDxOption(diagVersion:DxVersionTag= ''): Promise<DxOpt[]> {

    if(FunctionEnable.EnableClientAdvCache){
      if (!diagVersion) {
        diagVersion = await this.ICD10Version();
      }
      var k: keyof CacheObject = diagVersion=='2014'?'DxOpt2014':'DxOpt2023'
      await this.ObjectCachedService.load([k]);
      return await this.ObjectCachedService.get(k);
    }else{
      await this.dxLock.doInLock(async () => {
        if (!diagVersion) {
          diagVersion = await this.ICD10Version();
        }
        var renew = this.dxVersion !== diagVersion;
        this.dxVersion = diagVersion;
        if (!this.dxOption || renew) {
          this.dxOption = await this.histApi.GetDxOptions(diagVersion);
        }
      });
      return this.dxOption;
    }
  }
  allDxOption!: DxOpt[];
  /** 進階快取下 AllDxOpt 載入中的 Promise；並行呼叫共用同一次下載，載入結束即清除 */
  private allDxLoading?: Promise<void>;
  /** 取得全部院內診斷(一份，不分版本；ICD9 每筆依起迄日期套對應版本)，供診間依看診日自行篩選 */
  async GetAllDxOption(): Promise<DxOpt[]> {
    if (FunctionEnable.EnableClientAdvCache) {
      if (!this.allDxLoading) {
        this.allDxLoading = (async () => {
          try {
            await this.ObjectCachedService.load(['AllDxOpt']);
          } finally {
            delete this.allDxLoading;
          }
        })();
      }
      await this.allDxLoading;
      return await this.ObjectCachedService.get('AllDxOpt');
    } else {
      await this.dxLock.doInLock(async () => {
        if (!this.allDxOption) {
          this.allDxOption = await this.histApi.GetAllDxOptions();
        }
      });
      return this.allDxOption;
    }
  }
  /** 以 ICD10 申報碼(ApplyCode)查院內診斷，供 IC 卡等只帶申報碼的外部資料顯示用。
   *  不依日期過濾起迄日，舊版碼仍可查到。
   *  同一申報碼有多個院內碼時，優先取院內碼等於申報碼的那筆，沒有則取第一筆；查無回傳 undefined。
   *  回傳的是快取物件本身，呼叫端只能讀取不可修改 */
  async FindDxByApplyCode(applyCode: string): Promise<DxOpt | undefined> {
    if (!applyCode) { return undefined; }
    const allDx = await this.GetAllDxOption() ?? [];
    const matched = allDx.filter(d => d.ApplyCode === applyCode);
    return matched.find(d => d.Code === applyCode) ?? matched[0];
  }
  /** 以 ICD10 申報碼取診斷中文名，供 IC 卡等可能來自他院的申報碼顯示用。
   *  先查院內診斷(FindDxByApplyCode)；院內查無或無中文名時，以院所現行 ICD10 版本查標準診斷(後端依序 SDx、SPHc)。
   *  後端 GetDiagByCode 也會以院內碼(Code)比對，回傳的申報碼與查詢碼不同時視為查無，避免顯示其他申報碼的名稱。
   *  查無回傳 undefined；查詢失敗時拋出，由呼叫端決定如何降級 */
  async FindDxCNameByApplyCode(applyCode: string): Promise<string | undefined> {
    if (!applyCode) { return undefined; }
    const clinicDx = await this.FindDxByApplyCode(applyCode);
    if (clinicDx?.CName) { return clinicDx.CName; }
    const dx = await this.histApi.getDiagByCode(applyCode, await this.ICD10Version());
    return dx?.ApplyCode === applyCode && dx.CName ? dx.CName : undefined;
  }
  dxNotifyFlag = 0;
  async UpdateDx(dxOpt: { UpdateType: UpdateType, Data: DxOpt }[]) {
    var cachedDxOpt:DxOpt[];
    if(FunctionEnable.EnableClientAdvCache){
      cachedDxOpt = await this.GetDxOption()
    }else{
      cachedDxOpt = this.dxOption
    }

    if (cachedDxOpt) {
      dxOpt.forEach(x => {
        if (x.UpdateType == UpdateType.Insert) {
          // 避免重複
          var exist = cachedDxOpt.some(y => y.ApplyCode == x.Data.ApplyCode);
          if (!exist) {
            cachedDxOpt.push(x.Data);
          }

        } else if (x.UpdateType == UpdateType.Update) {
          //更新
          var opt = cachedDxOpt.find(y => y.ApplyCode == x.Data.ApplyCode)
          if (opt) {
            Object.assign(opt, x.Data);
          }
        } else if (x.UpdateType == UpdateType.Delete) {
          //留下沒有在移除清單中的
          cachedDxOpt = cachedDxOpt.filter(y => y.ApplyCode !== x.Data.ApplyCode);
        }
      })

      cachedDxOpt = cachedDxOpt.sort((a, b) => Compare(a.Code, b.Code));

      if(FunctionEnable.EnableClientAdvCache){
        this.ObjectCachedService.set('DxOpt2023',cachedDxOpt);
      }else{
        this.dxOption = cachedDxOpt
      }
      this.dxNotifyFlag = 1;
      setTimeout(() => {
        if(this.dxNotifyFlag ==1){
          this.dxNotifyFlag = 0;
          this.showNotify('院內診斷代碼已變更…');
        }
      }, 1500);
      //this.rxOption = await this.histApi.GetRxOptions();

    }
  }
    async GetTMDoctor(): Promise<ValueTextPair[]> {
    await this.ObjectCachedService.load(['TMDoctor']);
    return await this.ObjectCachedService.get('TMDoctor')
  }
  //#endregion

  async GetStatOpt(): Promise<StatOpts> {
    if(FunctionEnable.EnableClientAdvCache){
      await this.ObjectCachedService.load(['StatOpt']);
      return await this.ObjectCachedService.get('StatOpt');
    }else{
      await this.statLock.doInLock(async () => {
        if (!this.statOpt) {
          this.statOpt = await this.histApi.GetStatOptions();
        }
      });
      return this.statOpt;
    }

  }
  async UpdateStat(data: StatOpts) {
    var cachedStat:StatOpts;
    if(FunctionEnable.EnableClientAdvCache){
      cachedStat = await this.GetStatOpt()
    }else{
      cachedStat = this.statOpt
    }
    if (cachedStat) {
      if(FunctionEnable.EnableClientAdvCache){
        this.ObjectCachedService.set('StatOpt',cachedStat);
      }else{
        this.statOpt = cachedStat;
      }

      this.showNotify('近期常用項目已被更新');
    }

  }
  private showNotify(msg: string) {
    if (this.showDataChangedNotify) {
      this.notify.showInfo(msg);;
    }
  }


  public cleanRxCache() {
    if(FunctionEnable.EnableClientAdvCache){
      this.ObjectCachedService.delete(['RxOpt','RsOpt'])
    }else{
      delete this.rxOption;
      delete this.rsOption;
    }
  }

  public async reload(){
    if(FunctionEnable.EnableClientAdvCache){
      this.clearCache()
      await this.preload()
    }else{
      this.cmsPrintReports.clear();
      if(this.rxOption){
        delete this.rxOption;
        await this.GetRxOption();
        this.notify.showSuccess('已重載院內醫令')
      }
      if(this.rsOption){
        delete this.rsOption;
        await this.GetRsOption();
        this.notify.showSuccess('已重載院內套餐')
      }
      if(this.dxOption){
        delete this.dxOption;
        await this.GetDxOption();
        this.notify.showSuccess('已重載院內診斷')
      }
      for(let c of this.allICache){
        await c.reload();
      }
    }
    this.onReload.emit();
  }
  /**
   * 開啟參數編輯畫面(不包含hidden項目)
   * @param paraType 參數群組
   * @param fields 開放編輯的項目們，沒設定表示全開
   * @param display 依欄位覆寫顯示標題/提示，未指定的欄位沿用後端參數定義
   */
  async editParam<K extends keyof ParamMap>(paraType:K,fields?:(keyof ParamMap[K])[],
                  custom?:Partial<{[key in keyof ParamMap[K]]:(data:ParamMap[K])=>PromiseLike<void>}>,width: number = 450, height: number = 550,
                  display?:Partial<{[key in keyof ParamMap[K]]:{label?:string,tip?:string}}>){
    var def = await this.paramApi.GetDesc(paraType);
    var p = await this.paramApi.GetParams(paraType);
    var field:FormFieldCollection<ParamMap[K]> = {};
    def.forEach(x=>{
      if(fields && !fields?.some(y=>y == x.Key)){
        return;
      }
      var value = p[x.Key];
      if(value instanceof Array){
        value = value.join(',')
      }
      var d // :FieldDefineT<LAB001Params,''>
        = {
        name: x.Key,
        label:display?.[x.Key]?.label ?? x.Name,
        type: custom?.[x.Key]!=null?'button':
              x.DataType== ParameterDataType.Boolean?'check':
              x.DataType== ParameterDataType.Datetime?'date':
              x.DataType== ParameterDataType.Int?'number':
              x.DataType== ParameterDataType.String?'text':
              x.DataType== ParameterDataType.Mask?'text':
              x.DataType== ParameterDataType.Encryption?'text':
              x.DataType== ParameterDataType.Switch?'check':'text',
        value:value,
        tip:(display?.[x.Key]?.tip ?? x.Description)+' Ex:'+x.Value,
        onButton:custom?.[x.Key]!=null?custom[x.Key]:null,
        buttonText:custom?.[x.Key]!=null?'進階設定':null
      }
      field[x.Key] = d;
    })
    var ret = await this.ezForm.show<ParamMap[K]>({
      title:paraType,
      msg:'參數編輯',
      width:width,
      height:height,
      fields:field,
      closeValue:()=>null
    });
    if(ret){
      p = Object.assign(p,ret);
      try{
        await this.paramApi.UpdateParamGroup(paraType ,p);
        this.notify.showSuccess('更新完成');
      }catch(e){
        this.notify.showError('更新失敗');
      }
    }
    return p;
  }

  async ICD10Version(regDate: Date = null): Promise<DxVersionTag> {
    var opdParams = await this.getParam("OPD002");
    var verDate = regDate ? DateHelper.createDate(regDate) : DateHelper.createDate(new Date().setHours(0, 0, 0, 0));
    var icd102023StartDate = opdParams.DiagnosisICD102023StartDate ? DateHelper.createDate(opdParams.DiagnosisICD102023StartDate) : null;
    var version:DxVersionTag= (opdParams.DiagnosisICD102023ForceUse || (icd102023StartDate != null && verDate >= icd102023StartDate)) ? '2023' : '2014';
    return version;
  }

  /**
   * 取得目前牙科登入情境使用的北極星主機 URL；情境未設定時回退院所預設值。
   */
  public GetPolarisHostUrl(): string {
    const clinic = UserCache.getLoginUser().Clinic;
    const clinicType = Number(clinic?.Type);
    if (clinicType !== ClinicTypeEnum.DentistClinic && clinicType !== ClinicTypeEnum.WesternAndDentistClinic) {
      return '';
    }

    const loginSituation = this.session.getData('loginSituation');
    const situationUrl = this.normalizePolarisHostUrl(loginSituation?.PolarisHostUrl);
    if (situationUrl) {
      return situationUrl;
    }

    return this.normalizePolarisHostUrl(clinic?.PolarisHostUrl);
  }

  private normalizePolarisHostUrl(value: string): string {
    const trimmed = (value || '').trim();
    const suffixIndex = trimmed.search(/[?#]/);
    const baseUrl = suffixIndex >= 0 ? trimmed.substring(0, suffixIndex) : trimmed;
    const suffix = suffixIndex >= 0 ? trimmed.substring(suffixIndex) : '';
    return baseUrl.replace(/\/+$/, '') + suffix;
  }

  /**
   * 從參數 或工作階段取得EMR 路徑
   * @returns
   */
  public async GetEMRPath() {
    var paramHst001 = await this.getParam('HST001');
    // 取得系統參數設定的預設路徑
    var emrXmlPath = paramHst001?.EMRXmlPath || '';

    // 取得巡診相關設定
    var useOutVisit = this.session.getData('useOutVisit');
    var useOutVisitJail = this.session.getData('useOutVisitJail');

    // 如果是巡診模式,優先 emrXmlPath
    if (useOutVisit || useOutVisitJail) {
      var sessionEmrPath = this.session.getData('emrXmlPath');

      // 巡診模式下,完全以 session 中的設定為準
      emrXmlPath = sessionEmrPath || '';

      if (emrXmlPath) {
        console.log('使用巡診設定的電子病歷路徑:', emrXmlPath);
      } else {
        console.log('巡診模式:未設定電子病歷路徑,將不產生電子病歷');
      }
    } else {
      console.log('非巡診模式,使用系統參數的電子病歷路徑:', emrXmlPath);
    }
    return emrXmlPath;
  }
}

class loadHelper {
  private isLoadSubject: Subject<boolean> = new Subject<boolean>();
  isLoad = false;
  async doInLock(fn: () => {}) {
    if (this.isLoad) {
      await new Promise<boolean>((rs, rj) => {
        this.isLoadSubject.asObservable().subscribe(x => {
          rs(x);
        })
      })
    }
    this.isLoad = true;
    try {
      await fn()
    } catch (e) {
      throw e;
    } finally {
      this.isLoad = false;
      this.isLoadSubject.next(true);
    }
  }
}
export { EnumTypes };

